import { each } from 'underscore';
import { Subscription } from 'rxjs/Subscription';
export class UtilityFunctions {
  constructor() {
  }
  unSubscribeSubscriptions(subscriptions: Subscription[]) {
    each(subscriptions, (data) => {
      data.unsubscribe();
    });
  }
}





// WEBPACK FOOTER //
// /codebuild/output/src185846418/src/src/app/shared/utility-functions.ts